import { render, staticRenderFns } from "./ToggleChat.vue?vue&type=template&id=607accfc&scoped=true&"
import script from "./ToggleChat.vue?vue&type=script&lang=ts&"
export * from "./ToggleChat.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleChat.vue?vue&type=style&index=0&id=607accfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607accfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607accfc')) {
      api.createRecord('607accfc', component.options)
    } else {
      api.reload('607accfc', component.options)
    }
    module.hot.accept("./ToggleChat.vue?vue&type=template&id=607accfc&scoped=true&", function () {
      api.rerender('607accfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToggleChat.vue"
export default component.exports